<template>
    <div>

        <div class="row no-margin mt-4 ">  <!-- Abdullah chnaged classses here  -->
            <div class="ibox col-md-12 mb-0 px-4"> <!-- Abdullah added this div   -->
                <div class="ibox-title dashboard_title px-0"> <!-- Abdullah added this div   -->
                    <h4>General</h4>
                </div>

                <div class="ibox-content px-0 pt-4"> <!-- Abdullah added this div   -->
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group  id="start_month-group" label="First Month of the Leave Year" label-for="start_month">
                                <b-form-select id="start_month" name="start_month" :disabled="disabled_by_acl" v-model="start_month" :options="months" ></b-form-select>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group id="days_leave_year-group" label='Number of Days in Leave Year' label-for="days_leave_year">
                                <b-form-input id="days_leave_year" :disabled="disabled_by_acl" name="days_leave_year" v-model="days_leave_year"></b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-sm-12">
                            <b-form-group id="off_day_on_leave-group" label="Weekend & Public Holidays in leave days calculation" label-for="off_day_on_leave" >
                                <b-form-select id="off_day_on_leave" :disabled="disabled_by_acl" name="off_day_on_leave" v-model="off_day_on_leave" :options="off_day_on_leave_options"  v-b-tooltip.hover title="Will be applicable from future leave application"></b-form-select>
                            </b-form-group>
                        </div>

                        <!-- AbdullahFixed Commeted this code -->
                        <!-- <div class="col-sm-6">
                            <b-form-group id="approvers_depth-group" label="Approvers Level Depth" label-for="approvers_depth" >
                                <b-form-select style="max-width: 100%;" id="approvers_depth" name="approvers_depth" v-model="approvers_depth" :options="approvers_depth_options"></b-form-select>
                            </b-form-group>
                        </div> -->

                        <!-- AbdullahFixed Commeted this code -->
                        <!-- <div class="col-sm-6">
                            <b-form-group id="approval_forwarding-group" label="Approvers Forwarding" label-for="approval_forwarding" >
                                <b-form-select id="approval_forwarding" name="approval_forwarding" v-model="approval_forwarding" :options="yes_no"></b-form-select>
                            </b-form-group>
                        </div> -->
                    </div>

                    <div class="btn-wrapper text-center pt-5" v-if="!disabled_by_acl">
                        <b-button variant="primary" @click="saveSettings()" class="">Apply Changes</b-button>
                    </div>


                    <!-- Abdullah commented this code  -->
                     <!-- <br /><br />
                    <hr />
                    <div class="mt-4 clear-fx" v-if="!disabled_by_acl">
                        <b-button variant="success" @click="leaveYearClosing()" class="float-right">Finalize Carry for last leave year and unlock new leave year</b-button>
                    </div>

                    <br /><br />

                    <hr /> -->


                    <!-- Abdullah added this code  -->
                    <div class="ibox no-shadow border-2 mt-5 gray-border">
                        <div class="clearfix service_format_overview mt-2 mx-auto px-3 py-4">
                            <div class="font-medium text-secondary mb-2"  style="font-size: 18px;">Finalize Carry for last leave year and unlock new leave year</div>
                            <p class="text-secondary mb-0">Finalize the remaining leave balance from the last leave year and carry it forward to the new leave year. Once processed, the new leave year will be unlocked for leave allocation, balance updates, and employee leave processing. </p>
                            <div class="btn-wrapper text-center pt-5" v-if="!disabled_by_acl">
                                <b-button variant="primary" @click="leaveYearClosing()" class="custom-wizard-btn">Carry Forward to New Leave Year</b-button>
                            </div>
                        </div>
                    </div>

                    <l-a-mail-settings></l-a-mail-settings>

                </div>
            </div>


        </div>


    </div>
</template>
<script>
    export default{

        mounted() {

        },
        props: [],
        components: {
        },
        data(){

            return {

                company_id : 0 ,
                months: [{ value: 1, text: "January" },{ value: 2, text: "February"},{ value: 3, text: "March"},{ value: 4, text: "April"},{ value: 5, text: "May"},{ value: 6, text: "June"},{ value: 7, text: "July"},{ value: 8, text: "August"},{ value: 9, text: "September"},{ value: 10, text: "October"},{ value: 11, text: "November"},{ value: 12, text: "December", } ],

                start_month : 1,
                days_leave_year : 365,
                supper_user : true,
                disabled_by_acl : false,
                off_day_on_leave : 0,
                acl:this.$acl,

                   // AbdullahALC chnaged added this code
                approvers_depth : 1,
                approval_forwarding : 1,

                   // AbdullahALC chnaged added this code upto this

                off_day_on_leave_options:[

                    { value: "0", text: "Include weekend and public holidays in leave days calculation" },
                    { value: "1", text: "Skip weekend and public holidays in leave days calculation" },
                    { value: "2", text: "Include adjacent weekend and public holidays in leave days calculation" },
                ],

                // AbdullahALC chnaged added this code
                approvers_depth_options:[

                    { value: "1", text: "One Level" },
                    { value: "2", text: "Two Level" },
                    { value: "3", text: "Three Level" },
                ],

                yes_no: [

                    { value: "1", text: "Yes" },
                    { value: "0", text: "No" },
                ],

                 // AbdullahALC chnaged added this code upto this
            }
        },
        methods:{
            getSettings : function()
            {
                axios.get(this.$api_url+'/leave-attendances/settings' , {
                    params: {
                    }
                }).then(function(response){
                    this.start_month = response.data.start_month;
                    this.days_leave_year = response.data.days_leave_year;
                    this.off_day_on_leave = response.data.off_day_on_leave;

                }.bind(this));
            },
            saveSettings:function()
            {
                let currentObj = this;
                let formData = new FormData();
                formData.append('start_month', this.start_month);
                formData.append('days_leave_year', this.days_leave_year);
                formData.append('off_day_on_leave', this.off_day_on_leave);

                 // AbdullahALC chnaged added this code
                  formData.append('approvers_depth', this.approvers_depth);
                formData.append('approval_forwarding', this.approval_forwarding);

                 // AbdullahALC chnaged added this code upto this



                axios.post(this.$api_url+'/leave-attendances/settings', formData,)
                            .then(function (response)
                            {

                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });
                                this.getSettings();

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
            },
            leaveYearClosing:function()
            {
                let currentObj = this;
                let formData = new FormData();


                axios.post(this.$api_url+'/leave/year/closing', formData,)
                            .then(function (response)
                            {

                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.serverError(error);
                            });
            },



        },
        created: function(){
            this.getSettings();
            if(this.acl['leave-attendances'] != 2)
            {
                this.disabled_by_acl = true;
            }


        },
        computed:
        {

        }
    }
</script>
